import { ECMContentType } from './CertificateDocumentType'

export interface IContentType {
  name: string
  value: ECMContentType
}

export const CertificateTypeList: IContentType[] = [
  {
    name: 'Certificate',
    value: ECMContentType.Certificate,
  },
  {
    name: 'DoC',
    value: ECMContentType.Doc,
  },
  {
    name: 'Conformity Marking',
    value: ECMContentType.ConformityMarking,
  },
  {
    name: 'Withdrawal Letter',
    value: ECMContentType.WithdrawalLetter,
  },
  {
    name: 'Suspension Letter',
    value: ECMContentType.SuspensionLetter,
  },
]

export const TestReportTypeList: IContentType[] = [
  {
    name: 'Test Report',
    value: ECMContentType.TestReport,
  },
  {
    name: 'Classification Report',
    value: ECMContentType.ClassificationReport,
  },
  {
    name: 'Assessment Report',
    value: ECMContentType.AssessmentReport,
  },
  {
    name: 'Descriptive Report',
    value: ECMContentType.DescriptiveReport,
  },
  {
    name: 'Letter Report',
    value: ECMContentType.LetterReport,
  },
  {
    name: 'ETA Report',
    value: ECMContentType.Eta,
  },
  {
    name: 'UKTA Report',
    value: ECMContentType.Ukta,
  },
]
